import { useState } from 'react'
import { InfoIcon } from '@phosphor-icons/react'
import { Database } from '../../../../screens/Appconnect/Database/Database'
import { Hubspot } from '../../../Appconnect/Hubspot/Hubspot'
import { useBotActions } from '../../../../../api/hooks/botActions/useBotActions'
import { useModal, MODALS } from '../../../../modals'
import { sources } from '../../NewDatasetModal/ConnectDatasource/ConnectDatasource'
import {
    ScoopButton,
    ScoopText,
    ScoopTooltip,
    ScoopRow,
    ScoopCircularProgress,
    useToast,
} from '../../../../ui'
import styles from './DatasetCard.module.scss'

export const DatasetCard = ({ dataset, server, refreshInbox }) => {
    const [openConfigure, setOpenConfigure] = useState(false)
    const [openAdvanced, setOpenAdvanced] = useState(false)
    const toast = useToast()
    const { runBot, isRunning: isLoading } = useBotActions()
    const configureModal = useModal(MODALS.SOURCE.CONFIGURE)

    if (!dataset) return null

    const handleRunBot = () => {
        runBot({
            inboxID: dataset.inboxID,
            onSuccess: (results) => {
                if (results?.status === 'success') {
                    toast.success('App Connector ran successfully!')
                } else if (results?.status === 'error' || !results) {
                    toast.info(
                        'The process is taking some time, your new data will become available soon.'
                    )
                }
            },
            onError: (error) => {
                console.error('RunBot error:', error) // Debug log
                toast.info(
                    'The process is taking some time, your new data will become available soon.'
                )
            },
        })
    }

    const getDatasetType = () => {
        switch (dataset.inboxType) {
            case 'robot':
                return dataset.botService ? 'Data Connector' : 'File Upload'
            case 'calculated':
                return 'Blended'
            case 'api':
                return sources.find(
                    (source) => source.sourceValue === dataset?.extractDefinition?.connectorType
                )?.name
            case 'email':
                return 'Email'
            default:
                return 'Email'
        }
    }

    const getFrequency = () => {
        if (dataset.inboxType === 'robot' && !dataset.botService) return 'One-time'
        if (dataset.inboxType === 'email') return 'One-time'
        return 'Daily'
    }

    const items = [
        {
            label: 'Description',
            value: dataset?.description,
            description: 'Brief description of the dataset',
        },
        {
            label: 'Source',
            value: getDatasetType(),
            description: 'Where Scoop is sourcing the data from',
        },
        {
            label: 'Type',
            value: dataset?.transactional ? 'Transactional' : 'Snapshot',
            description:
                'Transactional reports store cumulative event records over time, while snapshot reports capture data at specific points for trend analysis.',
        },
        {
            label: 'Scoop Frequency',
            value: getFrequency(),
            description: 'The cadence at which Scoop will update the dataset.',
        },
    ]

    return (
        <>
            <ScoopRow className={styles.cardContainer}>
                <ScoopRow className={styles.itemsContainer}>
                    {items.map(
                        (item, index) =>
                            item.value && (
                                <ScoopRow key={index} className={styles.item}>
                                    <ScoopRow className={styles.itemLabel}>
                                        <ScoopText className={styles.labelText}>
                                            {item.label}
                                        </ScoopText>
                                        <ScoopTooltip title={item.description}>
                                            <div className={styles.iconWrapper}>
                                                <InfoIcon size={16} className={styles.itemIcon} />
                                            </div>
                                        </ScoopTooltip>
                                    </ScoopRow>
                                    <ScoopText className={styles.valueText}>{item.value}</ScoopText>
                                </ScoopRow>
                            )
                    )}
                </ScoopRow>
                <ScoopRow className={styles.actionsContainer}>
                    {items[1].value === 'Data Connector' && (
                        <ScoopButton variant="grey" onClick={handleRunBot}>
                            Extract data now
                        </ScoopButton>
                    )}
                    {!dataset.readOnly &&
                        !(dataset.inboxType === 'robot' && !dataset.botService) && (
                            <ScoopButton
                                variant="grey"
                                onClick={() => {
                                    configureModal.show({
                                        isEmailSource: dataset.inboxType === 'email',
                                        isTransactional: dataset.transactional,
                                        server,
                                        isEditing: true,
                                        inbox: dataset,
                                        refreshInbox,
                                        goToAdvance:
                                            dataset.inboxType === 'robot' &&
                                            dataset.botService === 'R19'
                                                ? () => {
                                                      setOpenAdvanced(true)
                                                      configureModal.hide()
                                                  }
                                                : undefined,
                                    })
                                }}
                            >
                                Configure
                            </ScoopButton>
                        )}
                    {isLoading && (
                        <ScoopCircularProgress
                            variant="indeterminate"
                            className={styles.loadingProgress}
                        />
                    )}
                </ScoopRow>
            </ScoopRow>
            {dataset.inboxType === 'robot' && dataset.botService === 'R19' && openAdvanced && (
                <Database
                    open={openAdvanced}
                    onClose={() => setOpenAdvanced(false)}
                    initialDatasetDetails={dataset}
                    afterSave={() => setOpenConfigure(false)}
                    stepBack={() => {
                        setOpenAdvanced(false)
                        setOpenConfigure(true)
                    }}
                />
            )}
            {items[1].value === 'Data Connector' && dataset.botService === 'R17' && (
                <Hubspot
                    open={openConfigure}
                    onClose={() => setOpenConfigure(false)}
                    initialDatasetDetails={dataset}
                    afterSave={() => setOpenConfigure(false)}
                />
            )}
        </>
    )
}
